import type { SiteEntity } from '../../types/site';
import { structuralEqual } from '../structuralEqual';

/** Every input/alias a read-time boundary migration can replace. */
export const SITE_BOUNDARY_READ_FIELDS = [
  'siteBoundaries', 'siteBoundaryAggregate', 'siteBoundary', 'siteArea',
  'sitePerimeter', 'siteCentroid', 'location', 'boundary_migrated_to_multi_parcel',
] as const;

export function sameSiteBoundaryReadBasis(
  before: Partial<SiteEntity>,
  current: Partial<SiteEntity>,
): boolean {
  return SITE_BOUNDARY_READ_FIELDS.every(field => structuralEqual(before[field], current[field]));
}
